const NotFound = () => {
  return (
    <>
      <h2>Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </>
  );
};
export default NotFound;
